import { jsx as _jsx } from "react/jsx-runtime";
import { cn } from '../../lib/utils';
const maxWidthClasses = {
    md: 'max-w-4xl',
    lg: 'max-w-5xl',
    xl: 'max-w-7xl',
    full: 'max-w-full'
};
/**
 * PageBody provides consistent padding and max-width for page content.
 * Padding aligns with the DashboardLayout header (pl-14 pr-6 py-6).
 *
 * @example
 * <PageBody>
 *   <PageToolbar>...</PageToolbar>
 *   <PageGrid>...</PageGrid>
 * </PageBody>
 */ export function PageBody({ children, maxWidth = 'xl', className, dataTestid }) {
    return /*#__PURE__*/ _jsx("div", {
        className: cn('pl-14 pr-6 py-6 min-w-[600px]', maxWidthClasses[maxWidth], className),
        "data-testid": dataTestid,
        children: children
    });
}
